// extracted by mini-css-extract-plugin
export var divider = "_s8-0";
export var systemMessage = "_s8-1";